export const ASYNC_FETCH = 'ITP_Confirmation/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS = 'ITP_Confirmation/ASYNC_FETCH_SUCCESS';
export const ASYNC_FETCH_FAILURE = 'ITP_Confirmation/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ITP_Confirmation/ASYNC_FETCH_INVALIDATE';
export const SET_ISCONFIRM_LOAD = 'ITP_Confirmation/SET_ISCONFIRM_LOAD';
/**
 * action types
 * @type {string}
 */
